var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fieldData.visible
    ? _c(
        "div",
        {
          staticClass: "field-display px-3",
          attrs: { id: _vm.fieldData.field_name + "_block" }
        },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              _vm.fieldData.field_type === "LinkButtonList"
                ? [
                    _c("input-link-button-list", {
                      attrs: { pdfLinkCovData: _vm.pdfLinkCov }
                    })
                  ]
                : [
                    _vm.fieldData["label"]
                      ? _c(
                          "div",
                          { staticClass: "col-6 mb-2 font-weight-bold" },
                          [_vm._v(_vm._s(_vm.fieldData["label"]))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      class: _vm.fieldData["label"]
                        ? "col-6 mb-2"
                        : "col-md-12 mb-3",
                      domProps: {
                        innerHTML: _vm._s(_vm.fieldValue(_vm.fieldData))
                      }
                    })
                  ]
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17da0982", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17da0982","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/FieldDisplay.vue
// module id = null
// module chunks = 